module.exports = __webpack_public_path__ + "img/lextimer.d22b7f4b.png";